import styled from 'styled-components';

const StyledLoadingContainer = styled.div`
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default StyledLoadingContainer;